import { render, staticRenderFns } from "./user_promotion.vue?vue&type=template&id=8e8b9778&scoped=true"
import script from "./user_promotion.vue?vue&type=script&lang=ts"
export * from "./user_promotion.vue?vue&type=script&lang=ts"
import style0 from "./user_promotion.vue?vue&type=style&index=0&id=8e8b9778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8b9778",
  null
  
)

export default component.exports